export const environment = {
  production: true,
  mode: 'spa',
  baseApiUrl: 'https://www.bettercoder.io/api',
  withCredentials: false
};
